<script lang="ts">
    import {onMount} from "svelte";

    export let text;

    onMount(() => {
        fetch('/backend/api/v2/store-sign/', {
            method: 'GET'
        }).then(r => r.json()).then((response) => {
            const {message} = response;
            text = message ? message : null;
        }).catch(() => {
            text = null;
        })
    });
</script>
{#if text}
    <section class="bg-accent py-ii sign relative">
        <div class="container text-c">
            {@html text}
        </div>
        <div class="times"
             style="font-family: sans-serif; font-weight:300; font-size: 25px; width: 25px; text-align: center"
             on:click={()=>text=null}>
            &times;
        </div>
    </section>
{/if}